import { Show, createSignal, createEffect, onCleanup } from 'solid-js'
import { useNavigate } from '@solidjs/router'
import { userStore } from '../../store'
import { IconLogout } from './Icons'
import { TokenCoin } from './TokenCoin'

export function UserMenu() {
  const [open, setOpen] = createSignal(false)
  const navigate = useNavigate()
  let menuRef: HTMLDivElement | undefined

  const user = () => userStore()
  const profile = () => user().profile
  const handle = () => profile()?.handle || 'User'
  const initial = () => (handle()[0] || 'U').toUpperCase()
  const tokens = () => profile()?.totalAvailableTokens ?? 0
  const email = () => profile()?.email || profile()?.handle || ''

  createEffect(() => {
    if (!open()) return
    const onClick = (e: MouseEvent) => {
      if (menuRef && !menuRef.contains(e.target as Node)) setOpen(false)
    }
    document.addEventListener('click', onClick, true)
    onCleanup(() => document.removeEventListener('click', onClick, true))
  })

  return (
    <div class="cf-user-menu" ref={menuRef}>
      <button class="cf-user-avatar-btn" onClick={() => setOpen(!open())}>
        <span
          style={{
            'font-family': "'Nunito', sans-serif",
            'font-weight': '900',
            'font-size': '14px',
            'line-height': '1',
          }}
        >
          {initial()}
        </span>
      </button>

      <Show when={open()}>
        <div class="cf-user-dropdown">
          {/* Header */}
          <div class="cf-ud-header">
            <div class="cf-ud-avatar">{initial()}</div>
            <div class="cf-ud-name">{handle()}</div>
            <div class="cf-ud-email">{email()}</div>
          </div>

          {/* Status */}
          <div class="cf-ud-status">
            <div class="cf-ud-section-label">Member Status</div>

            {/* Tier card */}
            <div class="cf-ud-tier-card">
              <span class="cf-ud-tier-icon">💎</span>
              <div>
                <div class="cf-ud-tier-name">VIP MEMBER</div>
                <div class="cf-ud-tier-since">Since {new Date().toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}</div>
              </div>
            </div>

            {/* Token row */}
            <div class="cf-ud-token-row">
              <div class="cf-ud-token-info">
                <TokenCoin size={18} />
                <div>
                  <div class="cf-ud-token-num">{tokens()}</div>
                  <div class="cf-ud-token-lbl">Tokens</div>
                </div>
              </div>
              <button
                class="cf-ud-buy-btn"
                onClick={() => {
                  setOpen(false)
                  userStore.buyTokensModal(true)
                }}
              >
                + Buy
              </button>
            </div>

            {/* XP row */}
            <div class="cf-ud-xp-row">
              <div class="cf-ud-xp-head">
                <div class="cf-ud-xp-level">
                  <span style={{ 'font-size': '14px', color: '#FF3CAC' }}>★</span>
                  Level 3
                </div>
                <div class="cf-ud-xp-count">720 / 1000 XP</div>
              </div>
              <div class="cf-ud-xp-bar">
                <div class="cf-ud-xp-fill" style={{ width: '72%' }} />
              </div>
              <button
                class="cf-ud-rewards-row"
                onClick={() => {
                  setOpen(false)
                  navigate('/subscriptions')
                }}
              >
                VIEW REWARDS
                <span class="cf-ud-rewards-chevron">›</span>
              </button>
            </div>
          </div>

          {/* Logout */}
          <button
            class="cf-ud-logout"
            onClick={() => {
              setOpen(false)
              userStore.logout()
            }}
          >
            <IconLogout size={14} />
            LOG OUT
          </button>
        </div>
      </Show>
    </div>
  )
}
